import * as actions from "./actionsTypes";

const initialState = {
  loading: false,
  loadingEmail: false,
  saveLoading: false,
  budgets: [],
  annualBudgets: {
    presupuesto_anual: null,
    presupuestos_mensuales: [],
  },
  budgetsLength: 0,
  annualBudgetsLength: 0,
  budgetsError: "",
  emailError: "",
  emailSuccess: false,
  formError: "",
};

export default function BudgetControlReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOADING_BUDGET_ACTIONS:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_BUDGET_ACTIONS:
      return { ...state, saveLoading: action.payload };

    case actions.GET_BUDGETS:
      return {
        ...state,
        budgets: action.payload.budgets,
        budgetsLength: action.payload.budgetsLength,
      };

    case actions.GET_ANNUAL_BUDGETS:
      return {
        ...state,
        annualBudgets: action.payload.annualBudgets || {},
        annualBudgetsLength: action.payload.annualBudgetsLength,
      };

    case actions.CLEAR_ANNUAL_BUDGETS:
      return {
        ...state,
        annualBudgets: [],
        annualBudgetsLength: 0,
      };

    case actions.CREATE_ANNUAL_BUDGET:
      return {
        ...state,
        annualBudgets: Array.isArray(state.annualBudgets)
          ? [...state.annualBudgets, action.payload]
          : [action.payload],
        loading: false,
      };

    case actions.CREATE_BUDGET:
      return {
        ...state,
        budgets: [...state.budgets, action.payload],
      };

    case actions.DELETE_BUDGET:
      return {
        ...state,
        budgets: state.budgets.filter((budget) => budget.id !== action.payload),
      };

    case actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE_LOADING:
      return { ...state, saveLoading: action.payload };

    case actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE:

      if (state.annualBudgets.presupuestos_mensuales) {
        const updatedMonths = state.annualBudgets.presupuestos_mensuales.map(
          (month) =>
            month.id === action.payload.id
              ? {
                  ...month,
                  monto_gastado: action.payload.monto_gastado,
                  fecha_gasto: new Date().toISOString(),
                  usuario_gasto: action.payload.usuario_gasto.id,
                }
              : month
        );

        return {
          ...state,
          annualBudgets: {
            ...state.annualBudgets,
            presupuestos_mensuales: updatedMonths,
          },
          saveLoading: false,
          budgetsError: null,
        };
      }

      return {
        ...state,
        annualBudgets: state.annualBudgets.map((budget) =>
          budget.id === action.payload.id ? action.payload : budget
        ),
        saveLoading: false,
      };

    case actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE_FAIL:
      return { ...state, budgetsError: action.payload, saveLoading: false };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.BUDGET_ACTIONS_FAIL:
      return { ...state, budgetsError: action.payload };

    case actions.SEND_EMAIL_LOADING:
      return {
        ...state,
        loadingEmail: true,
        emailError: "",
        emailSuccess: false,
      };

    case actions.SEND_EMAIL_SUCCESS:
      return { ...state, loadingEmail: false, emailSuccess: true };

    case actions.SEND_EMAIL_FAIL:
      return { ...state, loadingEmail: false, emailError: action.payload };

    default:
      return state;
  }
}
